import React, { useEffect, useState } from "react";
import { FieldRenderProps } from "react-final-form";
import { TextFieldProps } from "@material-ui/core/TextField";
import withFieldControl from "../FieldControl";
import { TextField, CharCounter, Column } from "./styles";

type Props = {
  required?: boolean;
} & TextFieldProps;

const TextFieldControl = ({
  autoFocus,
  autoComplete,
  input,
  label,
  required,
  type,
  error,
  meta,
  onInputChange,
  maxLength,
  numericLimit = 0,
  ...props
}: FieldRenderProps<any> & Props) => {
  const [length, setLength] = useState(0);
  useEffect(() => {
    setLength(input.value.length);
  }, []);
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;

    if (numericLimit) {
      value = value
        .replace(/[^0-9]/g, "")
        .replace(/^0+/, "")
        .slice(0, numericLimit);
      const numericValue = value ? parseInt(value, 10) : null;
      setLength(value.length);
      input.onChange(numericValue);
      onInputChange?.(numericValue);
    } else {
      setLength(value.length);
      input.onChange(event);
      onInputChange?.(value);
    }
  };

  return (
    <Column withMaxLength={maxLength}>
      <CharCounter>{maxLength ? `${length}/${maxLength}` : ""}</CharCounter>
      <TextField
        {...{ ...input, onChange }}
        type={type}
        label={label}
        helperText={(meta.touched && meta.error) || error}
        error={Boolean((meta.touched && meta.error) || error)}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        required={required}
        inputProps={{
          maxLength: maxLength,
          onKeyDown: e => {
            if (numericLimit && ["e", "E", "+", "-"].includes(e.key)) {
              e.preventDefault();
            }
          },
        }}
        {...props}
      />
    </Column>
  );
};

export default withFieldControl(TextFieldControl);
